import Backbone from 'backbone';
import M from 'backbone.marionette'
import T from './coteinput.html'

const valableCotes = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
const cotes = new Backbone.Collection([
    {value: '', caption: 'Non-spécifié', title : 'Non-spécifié'},
    {value: '1', caption : '1 - Participatif - amical', title: 'Participatif - amical'},
    {value: '2', caption : '2 - Récréatif', title: 'Récréatif'},
    {value: '3', caption : '3 - Récréatif fort', title: 'Récréatif fort'},
    {value: '4', caption : '4 - Récréatif dominant', title: 'Récréatif dominant'},
    {value: '5', caption : '5 - Compétitif', title: 'Compétitif'},
    {value: '6', caption : '6 - Compétitif fort', title: 'Compétitif fort'},
    {value: '7', caption : '7 - Compétitif dominant', title: 'Compétitif dominant'},
    {value: '8', caption : '8 - Élite', title: 'Élite'},
    {value: '9', caption : '9 - Semi-Pro', title: 'Semi-Pro'},
    {value: '10', caption : '10 - Pro', title: 'Pro'},
]);
const cotesShort = new Backbone.Collection([
    {value: '', caption: '-', title : 'Non-spécifié'},
    {value: '1', caption : '1 (A)', title: 'Participatif - amical'},
    {value: '2', caption : '2 (R)', title: 'Récréatif'},
    {value: '3', caption : '3 (R+)', title: 'Récréatif fort'},
    {value: '4', caption : '4 (R++)', title: 'Récréatif dominant'},
    {value: '5', caption : '5 (C)', title: 'Compétitif'},
    {value: '6', caption : '6 (C+)', title: 'Compétitif fort'},
    {value: '7', caption : '7 (C++)', title: 'Compétitif dominant'},
    {value: '8', caption : '8 (E)', title: 'Élite'},
    {value: '9', caption : '9 (SP)', title: 'Semi-Pro'},
    {value: '10', caption : '10 (P)', title: 'Pro'},
]);

const PlayerCoteItem= M.View.extend({
    tagName :'option',
    attributes: function(){
        var out = {
            value: this.model.get('value'),
            title: this.model.get('title')
        }
        if(this.getOption('selectedValue') == this.model.get('value')){
            out.selected = 'selected'
        }
        return out;
    },
    template: _.template('<%=caption%>'),
})

const Select = M.CollectionView.extend({
    tagName: 'select',
    triggers: {
        'change':'cote:changed'
    },
    attributes: function(){
        var out = {
            name: 'cote_' + this.model.get('entity_id'),
            value: this.model.get(this.getOption('coteAttr'))
        }
        if(this.getOption('readonly')){
            out.readonly = 'readonly';
            out.disabled = 'disabled';
        }
        return out;
    },
    childViewOptions: function(){
        return { 
            selectedValue: this.model.get(this.getOption('coteAttr')),
            coteAttr: this.getOption('coteAttr')
        }
    },
    className: 'form-control',
    childView: PlayerCoteItem
})

export const CoteInput = M.View.extend({
    template: _.template(T),
    modelEvents: {
        'change:state':'render'
    },
    coteAttr:'cote',
    childViewEventPrefix: 'childview',
    serializeData: function(){
        return _.extend(this.model.toJSON(), {
            readonly: this.getOption('readonly'),
            type: this.model.get(this.coteAttr + '_type'),
            value: this.model.get(this.coteAttr)
        })
    },
    initialize: function(){
        this.coteAttr = this.getOption('goalie') ? 'cote_g' : 'cote';
        this.modelEvents['change:' + this.coteAttr] = 'modelChanged';
        this.modelEvents['change:' + this.coteAttr + '_type'] = 'modelChanged';
        this.model.set({
            state: _.includes(valableCotes, this.model.get(this.coteAttr)) ? 'saved' : null
        })

    },
    events: {
        'change .cote_type':'onCoteTypeChanged'
    },
    regions: {
        'coteSelect':{
            el: '.coteSelect',
            replaceElement: true
        },
    },
    onRender: function(){
        this.showChildView('coteSelect', new Select({
            model: this.model, 
            readonly: this.getOption('readonly'), 
            coteAttr: this.coteAttr,
            collection : this.getOption('short') ? cotesShort : cotes}))
    },
    onCoteTypeChanged: function(){
        var sel = this.$el.find('.cote_type:checked');
        this.model.set(this.coteAttr + '_type', sel.length ? $(sel).val() : null);
        
    },
    onChildviewCoteChanged: function(view){
        var data = {}
        data[this.coteAttr] = view.$el.val();
        data[this.coteAttr + '_type'] = this.model.get(this.coteAttr+'_type') ? this.model.get(this.coteAttr +'_type') : 'o'
        this.model.set(data);
        //console.log('Child view '+this.coteAttr+' changed', view)
    },
    modelChanged: function(){
        this.render();
        var that = this;
        this.model.set('state', 'saving');
        var data = {
            entity_id: this.model.get('entity_id'),
            goalie: this.getOption('goalie') ? '1' : '0'
        }
        data[this.coteAttr] = this.model.get(this.coteAttr);
        data[this.coteAttr + '_type'] = this.model.get(this.coteAttr + '_type');
        console.log('data', data)
        // save it to server !
        $.ajax({
            url: site_url() + 'apis/recote/update_cote',
            type: 'post',
            data: data,
            success: function(){
                that.model.set('state', 'saved');
            },
            error: function(){
                that.model.set('state', 'error');
            }
        })
    }
});